<template>
  <component :is="props.as">
    <SkeletonText
      v-if="props.skeleton"
      :breakpoints-width="props.skeletonBreakpoints"
    />

    <slot v-else>
      {{ props.text }}
    </slot>
  </component>
</template>

<script setup lang="ts">
  import { SkeletonText } from '@/shared/ui/skeleton';

  import type { TextProps } from './types';

  const props = withDefaults(defineProps<TextProps>(), { as: 'span' });
</script>
